module.exports = __webpack_public_path__ + "static/media/ga_telesis_logo.4228cd72.svg";